import Vue from "vue";
import dateFormatter from "@/utility/dateFormatter";
export default Vue.extend({
    props: ["title", "icon", "name", "selectedDate"],
    filters: {
        toReadableMonth(date) {
            return dateFormatter.fromDateString(date).format.toMonthYearText;
        },
    },
});
